import React from 'react';
import { motion } from 'framer-motion';
import { UtensilsIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="w-full py-20 md:py-24 px-4 bg-light-green border-y border-primary-green/20" data-id="element-222">
      <div className="max-w-4xl mx-auto text-center" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="flex flex-col items-center" data-id="element-224">
          <div className="w-20 h-20 bg-primary-green rounded-full flex items-center justify-center mb-8 shadow-lg shadow-primary-green/30" data-id="element-225">
            <UtensilsIcon className="w-10 h-10 text-white" data-id="element-226" />
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-bold text-text-heading mb-4" data-id="element-227">
            MÉTODO MESA EN PAZ
          </h2>

          <h3 className="text-xl md:text-2xl font-bold text-[#3D7A5E] mb-6" data-id="element-228">
            El Sistema Completo para que tu Hijo Pase de Rechazar Todo a
            Explorar Alimentos Nuevos
          </h3>

          <div className="inline-block px-6 py-2 bg-white rounded-full shadow-sm border border-primary-green/20 mb-10" data-id="element-229">
            <span className="font-bold text-text-heading" data-id="element-230">
              4 Tomos + 2 Bonos
            </span>
          </div>

          <div className="space-y-4 text-lg md:text-xl text-text-body max-w-2xl mx-auto" data-id="element-231">
            <p className="font-medium" data-id="element-232">
              No es teoría. No es información genérica. No es "ya lo sabía".
            </p>
            <p className="text-2xl md:text-3xl font-heading font-bold text-text-heading mt-6" data-id="element-233">
              Es tu protocolo paso a paso. Tu sistema. Tu paz en la mesa.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}